document.addEventListener("DOMContentLoaded", function () {
  var menu_open = false;

  function navigation_keyboard_traversal(event) {
    //if the button pressed is one we're using to navigate
    if (["ArrowDown", "ArrowUp", "Escape"].includes(event.code)) {
      //prevent any jumping around
      event.preventDefault();
      var parent = event.target.parentNode; //if we're currently using the keyboard to navigate

      if (document.body.classList.contains('show-focus-outlines')) {
        switch (event.code) {
          case "ArrowDown":
            //if the menu is not open
            if (parent.classList.contains('menu-item-has-children')) {
              //close all open dropdown
              close_nav_menus(); //open it

              parent.classList.add('keyboard-nav-toggle');
              menu_open = true;
            }

            var next = get_next_tabbable(event.target);
            next.focus();
            break;

          case 'ArrowUp':
          case 'Escape':
            //close the dropdown
            close_nav_menus();
            break;
        }
      }
    }
  }

  function close_nav_menus() {
    var open_menus = document.getElementsByClassName('keyboard-nav-toggle');

    if (open_menus.length > 0) {
      for (var i = 0; i < open_menus.length; i++) {
        open_menus[i].classList.remove('keyboard-nav-toggle');
      }

      menu_open = false;
    }
  }

  function get_next_tabbable(element) {
    var universe = document.querySelectorAll('input, button, select, textarea, a[href]');
    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });
    var index = list.indexOf(element);
    return list[index + 1] || list[0];
  }

  document.getElementsByTagName('header')[0].addEventListener('keydown', navigation_keyboard_traversal);
});